import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ApplicationUpdatePage = lazy(() => import('../views/update/ApplicationUpdatePage'));

export function ApplicationUpdatePageLazy() {
	return (
		<PageSuspense>
			<ApplicationUpdatePage />
		</PageSuspense>
	);
}
